import { render, staticRenderFns } from "./ModalEncerradas.vue?vue&type=template&id=36b7001a&scoped=true&"
import script from "./ModalEncerradas.vue?vue&type=script&lang=js&"
export * from "./ModalEncerradas.vue?vue&type=script&lang=js&"
import style0 from "./ModalEncerradas.vue?vue&type=style&index=0&id=36b7001a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b7001a",
  null
  
)

export default component.exports